import { render, staticRenderFns } from "./CurrencyTextField.vue?vue&type=template&id=9aa857ca&scoped=true"
import script from "./CurrencyTextField.vue?vue&type=script&lang=js"
export * from "./CurrencyTextField.vue?vue&type=script&lang=js"
import style0 from "./CurrencyTextField.vue?vue&type=style&index=0&id=9aa857ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aa857ca",
  null
  
)

export default component.exports